// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"6941fa37","213":"1f713d6f","337":"5c1bfec9","455":"814953b1"}[chunkId] + ".chunk.js";
};